import { StorageService } from './../storage/storage.service';
import { Injectable } from '@angular/core';
import { document } from 'ngx-bootstrap/utils';

@Injectable({providedIn: 'root'})
export class UtilService {
  constructor(
    private storage: StorageService
  ) { }

  getEnv() {
    // New mock
    // this.storage.setStorage('ae', "eyJhY2NvdW50X2lkIjoiNiIsImFjY291bnRfbmFtZSI6IkogQWNjb3VudCIsInNpdGVfaWQiOiIyNzYiLCJlY21fc2l0ZV91cmwiOiJodHRwOi8vMzUuMjQwLjIxOS4xNjQ6ODkvIiwid2Vic2VydmljZV9hcGkiOiJodHRwOi8vMzUuMjQwLjIxOS4xNjQ6MzAxMS8iLCJlY21fYXBpIjoiaHR0cDovLzM1LjI0MC4yMTkuMTY0Ojg5L3N0bWFwaS9wYXJlbnRwb3J0YWwvIiwibGl2ZV9zZWFyY2giOiJodHRwOi8vMzUuMjQwLjIxOS4xNjQ6ODkvbGliL3BlcmZvcm1fZnVuY3Rpb24ucGhwP2Q9bGl2ZXNlYXJjaCZmPW1vdmVtZW50X2FkZHJlc3MtYmFja2VuZC5waHAiLCJtYXBib3hLZXkiOiJway5leUoxSWpvaWNHaHBjMmwwYTNWdUlpd2lZU0k2SW1OcmJqaGtkbWRsTXpBeFkyY3lkVzFuYjNSMU5qazJOemtpZlEuUHhuMnBRWF9OQ1lCLWJMakNKRWRVdyIsImtleSI6IjE1ODc0NTY5ODI1NDU0NzAwIiwic2VjcmV0a2V5IjoiNzBlNDA1YTMxOGM2ZmM2N2M0ZTc1M2EyMTU4YzRkNmEiLCJzY2hlbWEiOiJaV050WDJwdmRYSnVaWGxmYzNSdFgyRnBjZz09IiwidGltZV96b25lIjoiQXNpYS9CYW5na29rIiwiZGVmYXVsdF9yZWdpb24iOnsibG9uIjoxNTEuMTAxNTk2LCJsYXQiOi0zMy44NzA2NDR9LCJsb2NhbGhvc3Q6NDIwMCI6eyJsYXRlIjp0cnVlLCJoaWRlX3JvdXRlIjp7ImFtIjp0cnVlLCJwbSI6ZmFsc2V9fSwiZXhwaXJlX2RhdGUiOiIyMDIzLTA0LTEwIn0=");

    let ae = this.storage.getStorage('ae');

    let accountDetail = JSON.parse(atob(ae));
    return accountDetail;
  }
  
  /**
   * 
   * @param exception text value exception date
   * @param fullFormat false is short format // true is full format
   * 
   */
  daysOfWeek(exception='' ,fullFormat = true){
        let  Week = {
                            full: {  
                                      0:"Sunday",
                                      1:"Monday",
                                      2:"Tuesday",
                                      3:"Wednesday",
                                      4:"Thursday",
                                      5:"Friday",
                                      6:"Saturday"
                              },
                              short : {  
                                      0:"Sun",
                                      1:"Mon",
                                      2:"Tue",
                                      3:"Wed",
                                      4:"Thu",
                                      5:"Fri",
                                      6:"Sat"
                              }

                          }
      let days = fullFormat ? Week.full : Week.short;
      
      if(exception==''){
          return {
              daysTxt : "Everyday",
              daysOfWeek : days
          }
      }
      
      let keepContinue = true;
      let txt = '';
      let txtArray = [];
      let arrayException = exception.split(',')
      let objectkey =    Object.keys(days);   
      objectkey.forEach((val, index)=>{
        if( ( arrayException.indexOf(val) > -1 ) || ( val == '0' && arrayException.indexOf('7') > -1) ){
            if( txt != ''  || txtArray.length > 0) keepContinue = false
            delete days[val];
        }else{
            if(keepContinue)  txtArray.push(days[val]);
            if(!keepContinue) txt += "," + days[val]; 
        }
      }) 
      if(txt == '' && txtArray.length > 0) { // From - To format
          txt = txtArray[0] + ' - ' + txtArray[txtArray.length-1] ;
      }else{
          txt = txt.substr(1);
          if(txtArray.length > 0) txt = txtArray.join(',') + ', ' + txt;
      }
      return {
              daysTxt : txt,
              daysOfWeek : days
          }
     }

     
  /**
   * 
   * @param assign text value assign date
   * @param fullFormat false is short format // true is full format
   * 
   */
  assignDaysOfWeek(assign='' ,fullFormat = true){
        let  Week = {
                            full: {  
                                      0:"Sunday",
                                      1:"Monday",
                                      2:"Tuesday",
                                      3:"Wednesday",
                                      4:"Thursday",
                                      5:"Friday",
                                      6:"Saturday"
                              },
                              short : {  
                                      0:"Sun",
                                      1:"Mon",
                                      2:"Tue",
                                      3:"Wed",
                                      4:"Thu",
                                      5:"Fri",
                                      6:"Sat"
                              }

                          }
      let days = fullFormat ? Week.full : Week.short;
      
      if(assign==''){
          return {
              daysTxt : "Everyday",
              daysOfWeek : days
          }
      }
      
      let keepContinue = true;
      let txt = '';
      let txtArray = [];
      let arrayAssign = assign.split(',')
      let objectkey =    Object.keys(days);   
      objectkey.forEach((val, index)=>{
        if( ( arrayAssign.indexOf(val) > -1 ) || ( val == '0' && arrayAssign.indexOf('7') > -1) ){
            if(keepContinue)  txtArray.push(days[val]);
            if(!keepContinue) txt += "," + days[val]; 
        }else{
            if( txt != ''  || txtArray.length > 0) keepContinue = false
            delete days[val];
        }
      }) 
      if(txt == '' && txtArray.length > 0) { // From - To format
          txt = txtArray[0] + ' - ' + txtArray[txtArray.length-1] ;
      }else{
          txt = txt.substr(1);
          if(txtArray.length > 0) txt = txtArray.join(',') + ', ' + txt;
      }
      return {
              daysTxt : txt,
              daysOfWeek : days
          }
  }

  dowColors(day="-1") {
    let dow = {
      0: "#ff0000",
      1: "#ffff00",
      2: "#ffc0cb",
      3: "#008000",
      4: "#ffa500",
      5: "#00bfff",
      6: "#800080",
      '-1': "#ffffff",
    }

    return dow[day];
  }
  
  timeFormat(time){
   let dummyDate = new Date('1970-01-01T'+ time); // dummy date at 1970-01-01  just to mkae sure new date with correct full datetime format
   return this.str_pad(dummyDate.getHours())+":"+this.str_pad(dummyDate.getMinutes());
  }
  str_pad(n) {
   return String("00" + n).slice(-2);
  }
  stripslashes (str) {
    return (str + '').replace(/\\(.?)/g, function (s, n1) {
      switch (n1) {
      case '\\':
        return '\\';
      case '0':
        return '\u0000';
      case '':
        return '';
      default:
        return n1;
      }
    });
  }

  controlNavIcon(isSet=false, isShowLate=false){
    let lateRoute = JSON.parse(this.storage.getStorage("lateRoute"));
    let job_name = '';
    let isShowLateRoute = (lateRoute && lateRoute['isShowLateRoute']) ? lateRoute['isShowLateRoute'] : false;
    if(isSet){
      let env = this.getEnv()
      let arrStore = {};
      isShowLateRoute = false
      if(env && env[window.location.host]?.late && isShowLate){
        isShowLateRoute = true;
        job_name = 'late';
        
      }
      arrStore['isShowLateRoute'] = isShowLateRoute;
      arrStore['job_name'] = job_name;
      this.storage.setStorage("lateRoute", JSON.stringify(arrStore));
    }
    

    let showHome = "block";
    let showLate = "none";
    if(isShowLateRoute){ // show late
      showHome = "none";
      showLate = "block";
    }

    document.getElementsByClassName('nav-home').forEach(function(e) {
      e.style.display = showHome
   });
    document.getElementsByClassName('nav-late').forEach(function(e) {
      e.style.display = showLate
    });

  }


  
}
